<div class="page-header">
    <h2>Business Review</h2>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner> 
<div class="container p-20">
                <p-table [responsive]="true" [value]="w9List" [paginator]="false" >

                    <!-- Header -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                Business/Organization                                
                            </th>                            
                            <th>
                                Submitted                                
                            </th>
                            <th>
                                Tax ID (EIN)                               
                            </th>                            
                            <th>
                                IRS Tax Form W-9
                            </th>
                            <th>
                                Status
                            </th>
                            <th>Replace W-9</th>
                        </tr>
                    </ng-template>

                    <!-- Body -->
                    <ng-template pTemplate="body" let-w9>
                        <tr>
                            <td>
    <a class="review-link"
       (click)="goToAccountSettings(w9)">
        {{ w9.companyName }}
    </a>
</td>                            
                            <td>{{ w9.uploadedAt | date:'MM/dd/yyyy' }}</td>
                            <td>{{ w9.employerIdentificationNumber }}</td>                         
                            <td><a class="review-link" (click)="downloadFile(w9.originalFileName)">{{ w9.originalFileName }}</a>
                            </td>
                            <td><div class="field mb-0"><select [(ngModel)]="w9.verificationStatus" >                       
                               <option *ngFor="let status of w9.statusOptions" [value]="status.value">
                                {{ status.label }}
                               </option>
                               </select>
                               </div>                                
                            </td>
                            <td>
  <i *ngIf="w9.verificationStatus != '2'" class="pi pi-upload replace-icon"
     title="Replace W-9"
     (click)="goToReplaceW9(w9)">
  </i>
</td>
                        </tr>
                    </ng-template>
                </p-table>
            <div class="actions mt-30">
            <button type="button" (click)="cancel()">Cancel</button>
            <button type="submit" (click)="submit()">Submit</button>
           </div>
</div>
<p-dialog header="{{ dialogSummary }}"
  [styleClass]="dialogSummary === 'Success' ? 'success-dialog' : 'success-dialog error'" [(visible)]="modalDlg"
  [closable]="false" [closeOnEscape]="false" [modal]="true" [dismissableMask]="false" [style]="{ width: '580px' }"
  [breakpoints]="{ '640px': '95vw' }">

  <div class="dialog-body" [innerHTML]="dialogMsg"></div>

  <ng-template pTemplate="footer">
    <div class="actions">
      
      <!-- SUCCESS / ERROR BUTTON -->
      <ng-container>
        <button type="button" class="button-primary" (click)="okClicked()">
          Ok
        </button>
      </ng-container>

    </div>
  </ng-template>
</p-dialog>



        
